import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Update;
var _excluded = ["date", "sessions", "onRefresh", "isFromApps"];
import Update from '@crehana/compass.icons.outline/Update';
import { cn } from '@crehana/compass.ui/v2';
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";
import { isToday } from "../../utils/isToday";
import { DateSessionHeader } from "./DateSessionHeader";
import { LiveSessionCardDeprecated } from "./LiveSessionCardDeprecated";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DateWithSessionsList = function DateWithSessionsList(_ref) {
  var date = _ref.date,
    sessions = _ref.sessions,
    onRefresh = _ref.onRefresh,
    isFromApps = _ref.isFromApps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t;
  var isTodaySessions = isToday(date);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn('tw-flex tw-justify-between tw-items-center tw-px-1.6 tw-mb-1.6', 'tw-pb-0.8 tw-border-b-[0.5px] tw-border-solid', isTodaySessions ? 'tw-border-neutral-dark-300 dark:tw-border-neutral-dark-600' : 'tw-border-neutral-light-400 dark:tw-border-neutral-dark-600'),
      children: [/*#__PURE__*/_jsx(DateSessionHeader, {
        date: date
      }), onRefresh && isTodaySessions && /*#__PURE__*/_jsxs("button", {
        className: "tw-font-subtitle5 tw-text-primary-light-500 tw-flex tw-items-center tw-gap-0.4",
        type: "button",
        onClick: onRefresh,
        children: [_Update || (_Update = /*#__PURE__*/_jsx(Update, {
          className: "tw-text-inherit dark:tw-text-secondary-light-500",
          size: 20
        })), ' ', /*#__PURE__*/_jsxs("span", {
          className: "tw-hidden md:tw-block dark:tw-text-secondary-light-500",
          children: [t('CTA_UPDATE_SESSIONS_LIST'), ' ']
        })]
      })]
    }), /*#__PURE__*/_jsx("ol", {
      className: "tw-space-y-1.6",
      children: sessions.map(function (session) {
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(LiveSessionCardDeprecated, _objectSpread({
            session: session,
            isFromApps: isFromApps
          }, otherProps))
        }, session.id);
      })
    })]
  });
};